var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vl-layer-image',{attrs:{"visible":_vm.overlay.visible,"opacity":_vm.overlay.opacity,"extent":_vm.overlayExtent,"z-index":_vm.overlay.zIndex}},[_c('vl-source-image-static',{attrs:{"url":_vm.overlay.url,"extent":_vm.overlayExtent,"size":_vm.overlaySize,"projection":_vm.projectionName,"load-func":_vm.imageLoadFunction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }